import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";

function GeoJsonLayer({ data }) {
    const map = useMap();

    useEffect(() => {
        if (!map || !window.google || !data) return;

        // データが有効なGeoJSON形式かチェック
        if (!isValidGeoJson(data)) {
            console.error('Invalid GeoJSON data:', data);
            return;
        }

        try {
            const layer = new window.google.maps.Data();
            layer.addGeoJson(data);
            layer.setStyle((feature) => {
                return {
                    fillColor: feature.getProperty("fill") || "#CCCCCC",
                    fillOpacity: feature.getProperty("fill-opacity") ?? 0.4,
                    strokeColor: feature.getProperty("stroke") || "#000000",
                    strokeWeight: feature.getProperty("stroke-width") ?? 1,
                    clickable: false,
                };
            });
            layer.setMap(map);

            return () => {
                layer.setMap(null);
            };
        } catch (error) {
            console.error('Error adding GeoJSON to map:', error);
        }
    }, [map, data]);

    return null;
}

// GeoJSONデータが有効かチェックする関数
function isValidGeoJson(data) {
    if (!data || typeof data !== 'object') {
        return false;
    }

    // FeatureCollectionの場合
    if (data.type === 'FeatureCollection' && Array.isArray(data.features)) {
        return true;
    }

    // Featureの場合
    if (data.type === 'Feature' && data.geometry) {
        return true;
    }

    // Geometryの場合
    if (data.type && ['Point', 'LineString', 'Polygon', 'MultiPoint', 'MultiLineString', 'MultiPolygon', 'GeometryCollection'].includes(data.type)) {
        return true;
    }

    return false;
}

export default GeoJsonLayer;
